export const MealSize = (json: IMealSize): IMealSizeModel => {
	const fromJSON = (itemJson: IMealSize) => {
		const { is_active, ...rest } = itemJson
		return {
			isActive: is_active,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const mealSizeToJSON = (obj: Partial<IMealSizeModel>): Partial<IMealSize> => {
	const { isActive, ...rest } = obj
	return {
		is_active: isActive,
		...rest,
	}
}

export const PriceTier = (json: IMealPriceTier): IMealPriceTierModel => {
	const fromJSON = (itemJson: IMealPriceTier) => {
		const {
			meal_kind,
			meal_price_tier,
			meal_size_id,
			meal_size,
			meal_type,
			is_active,
			created_at,
			updated_at,
			...rest
		} = itemJson
		return {
			mealKind: meal_kind,
			mealPriceTier: meal_price_tier,
			mealSizeID: meal_size_id,
			mealSize: meal_size ? MealSize(meal_size) : null,
			mealType: meal_type,
			isActive: is_active,
			createdAt: created_at,
			updatedAt: updated_at,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const priceTierToJSON = (obj: Partial<IMealPriceTierModel>): Partial<IMealPriceTier> => {
	const { mealKind, mealPriceTier, mealSizeID, mealType, isActive, ...rest } = obj
	return {
		meal_kind: mealKind,
		meal_price_tier: mealPriceTier,
		meal_size_id: mealSizeID,
		meal_type: mealType,
		is_active: isActive,
		...rest,
	}
}
